<template>
  <div class="d-flex gap-10" :class="direction === 'column' ? 'flex-column' : 'flex-row'">
    <div
      v-for="metric in metrics"
      :key="metric.name"
      class="d-flex flex-column gap-2"
      :style="direction === 'row' ? 'width: 50%' : ''"
    >
      <div class="d-flex flex-column">
        <span class="font-size-20 font-weight-medium mb-2">{{ metric.name }}:</span>
        <span class="font-size-20 font-weight-medium">
          {{ formatMetricValue(metric.value) }} {{ currentSections[metric.name].name }}
        </span>
      </div>
      <div class="d-flex flex-column gap-2">
        <div class="progress p-relative">
          <div
            class="p-relative"
            :style="`background-color: ${currentSections[metric.name].color}; width: ${
              metricValuesWidth[metric.name]
            }%; height: 100%; z-index: 10`"
          />
          <template v-for="section in metric.sections">
            <div
              v-if="section.limit !== metric.max"
              :key="section.name"
              class="section-limiter"
              :style="`left: ${calculateMetricPercentage(metric, section.limit)}%`"
            />
          </template>
        </div>
        <div class="d-flex flex-row justify-space-between font-size-11 text-muted p-relative">
          <span>{{ metric.min }}</span>
          <span>{{ metric.max }}</span>
          <template v-for="section in metric.sections">
            <span
              v-if="section.limit !== metric.max"
              :key="section.name"
              class="section-limiter-label"
              :style="`left: ${calculateMetricPercentage(metric, section.limit)}%`"
            >
              {{ section.limit }}
            </span>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { PropOptions } from 'vue'
import { Method, Computed } from '@/_typedefs'
import { Metric, MetricSection } from './SideResult.vue'

export default {
  props: {
    /** @type {PropOptions<Metric[]>} */
    metrics: {
      type: Array,
      required: true,
    },
    /** @type {PropOptions<Record<string, MetricSection>>} */
    currentSections: {
      type: Object,
      required: true,
    },
    direction: {
      type: String,
      default: 'column',
    },
  },
  computed: {
    /** @type {Computed<Record<string, number>>} */
    metricValuesWidth() {
      return Object.fromEntries(
        this.metrics.map((metric) => [metric.name, this.calculateMetricPercentage(metric, metric.value)]),
      )
    },
  },
  methods: {
    /** @type {Method<[metric: Metric, value: number], number>} */
    calculateMetricPercentage(metric, value) {
      return ((value - metric.min) / (metric.max - metric.min)) * 100
    },
    /** @type {Method<[value: number], number>} */
    formatMetricValue(value) {
      return Intl.NumberFormat('en-US', { maximumFractionDigits: 1, minimumFractionDigits: 1 }).format(value)
    },
  },
}
</script>

<style></style>
